
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources/free-whatsapp-message-templates",
      function () {
        return require("private-next-pages/resources/free-whatsapp-message-templates/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resources/free-whatsapp-message-templates"])
      });
    }
  